import React from 'react';

import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SearchHeader = ({ 
  searchQuery, 
  setSearchQuery, 
  statusFilter, 
  setStatusFilter,
  locationFilter,
  setLocationFilter,
  dateRangeStart,
  setDateRangeStart,
  dateRangeEnd,
  setDateRangeEnd,
  onSearch,
  onReset,
  onAdvancedSearch,
  onSavePreset
}) => {
  const statusOptions = [
    { value: 'all', label: 'Alle Status' },
    { value: 'active', label: 'Aktiv' },
    { value: 'inactive', label: 'Inaktiv' },
    { value: 'pending', label: 'Ausstehend' },
    { value: 'archived', label: 'Archiviert' }
  ];

  const locationOptions = [
    { value: 'all', label: 'Alle Standorte' },
    { value: 'berlin', label: 'Berlin' },
    { value: 'munich', label: 'München' },
    { value: 'hamburg', label: 'Hamburg' },
    { value: 'cologne', label: 'Köln' },
    { value: 'frankfurt', label: 'Frankfurt' },
    { value: 'stuttgart', label: 'Stuttgart' },
    { value: 'dusseldorf', label: 'Düsseldorf' },
    { value: 'dortmund', label: 'Dortmund' }
  ];

  return (
    <div className="bg-card border-b border-border sticky top-0 z-20">
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-foreground">Klientensuche und Verzeichnis</h1>
            <p className="text-sm text-muted-foreground mt-1">Erweiterte Suchfunktionen für schnellen Zugriff auf Klientendaten</p>
          </div>
          <div className="flex items-center gap-3">
            <Button variant="outline" iconName="Save" iconPosition="left" onClick={onSavePreset}>
              Suche speichern
            </Button>
            <Button variant="default" iconName="Search" iconPosition="left" onClick={onAdvancedSearch}>
              Erweiterte Suche
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
          <div className="lg:col-span-2">
            <Input
              type="search"
              placeholder="Suche nach Name, ID, Beruf..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              className="w-full"
            />
          </div>
          
          <Select
            placeholder="Status auswählen"
            options={statusOptions}
            value={statusFilter}
            onChange={setStatusFilter}
          />

          <Select
            placeholder="Standort auswählen"
            options={locationOptions}
            value={locationFilter}
            onChange={setLocationFilter}
            searchable
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Input
            type="date"
            label="Von Datum"
            value={dateRangeStart}
            onChange={(e) => setDateRangeStart(e?.target?.value)}
          />

          <Input
            type="date"
            label="Bis Datum"
            value={dateRangeEnd}
            onChange={(e) => setDateRangeEnd(e?.target?.value)}
          />

          <div className="flex items-end gap-2">
            <Button variant="default" fullWidth iconName="Search" iconPosition="left" onClick={onSearch}>
              Suchen
            </Button>
          </div>

          <div className="flex items-end gap-2">
            <Button variant="outline" fullWidth iconName="X" iconPosition="left" onClick={onReset}>
              Zurücksetzen
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchHeader;